import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Home",
    component: () => import("../views/Home.vue"),
  },
  {
    path: "/kurumsal",
    name: "Corporate",
    redirect: "/kurumsal/hakkimizda",
    children: [
      {
        path: "hakkimizda",
        name: "About",
        component: () => import("../views/Corporate.vue"),
      },
      {
        path: "vizyon-misyon",
        name: "Vision",
        component: () => import("../views/Corporate.vue"),
      },
    ],
  },
  {
    path: "/faaliyet-alanlari",
    name: "Activities",
    component: () => import("../views/Activities.vue"),
  },
  {
    path: "/faaliyet-alanlari/:sector",
    name: "ActivityDetail",
    component: () => import("../views/Activities.vue"), // Placeholder
  },
  {
    path: "/projeler",
    name: "Projects",
    component: () => import("../views/Projects.vue"),
  },
  {
    path: "/projeler/:id",
    name: "ProjectDetail",
    component: () => import("../views/ProjectDetail.vue"),
  },
  {
    path: "/medya",
    name: "Media",
    component: () => import("../views/Media.vue"),
  },
  {
    path: "/iletisim",
    name: "Contact",
    component: () => import("../views/Contact.vue"),
  },
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
  scrollBehavior(to, from, savedPosition) {
    if (savedPosition) {
      return savedPosition;
    } else {
      return { top: 0 };
    }
  },
});

export default router;
